/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, qty: NonNullable<unknown>, unit: NonNullable<unknown> }} Pos_Lot_Debt_Warning_LineInputs */

const vi_pos_lot_debt_warning_line = /** @type {(inputs: Pos_Lot_Debt_Warning_LineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}: thiếu ${i?.qty} ${i?.unit}`)
};

/**

* @param {Pos_Lot_Debt_Warning_LineInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pos_lot_debt_warning_line = /** @type {((inputs: Pos_Lot_Debt_Warning_LineInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pos_Lot_Debt_Warning_LineInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pos_lot_debt_warning_line(inputs)
});